import styled from "@emotion/styled";

export const Btns = styled.div`
  width:100%;
  position:relative;
  height:100%;
  display:table;
  
  
  button{
      border-radius : ${props => props.brdr ? props.brdr : "4px"};
      border    : none;
      cursor    : ${props => props.cursor};
      min-height:100%;
      width     :100%;
      height    : ${props => props.hg ? props.hg + "px" : "50px"};
      text-align: ${props => props.align ? props.align : "center"};
      background: ${props => props.bg};
      color     : ${props => props.color};
      box-shadow: 0 1px 2px rgba(0,0,0,.15);
      position:relative;
      line-height:1.3em;
      transform:scale(1) translateZ(0);
      backface-visibility: hidden;
      transition: all 500ms cubic-bezier(0.190, 1.000, 0.220, 1.000);
      min-height:100%;
      padding:.5em;
      
      img{
        opacity: ${props => props.img};
      }
 
      &:focus{
        outline:none!important; 
      }
  
      &:hover{
        background-color: ${props => props.bgHover};
        box-shadow: ${props => props.shadow };
      }
  
      &:disabled{
        cursor:${props => props.loading ? "waiting" : "not-allowed"};
        background-color: ${props => props.bg};
      }
  }
  
  .loading{
    position:absolute;
    top:0;
    left:0;
    height:100%;
    width:100%;
    cursor:${props => props.cursor };
    
    .circle{
            height:${props => props.hg ? props.hg - 10 + "px" : "40px"};     
            width:${props => props.hg ? props.hg - 10 + "px" : "40px"};
            border-radius: 50%;
            border:2px solid rgba(0,0,0,.1);
            border-color: rgba(0,0,0,.2) rgba(0,0,0,.2) rgba(0,0,0,.2) ${props => props.loading};
            animation: girarN .5s ease-out infinite;     
     }
  }
`;


export const BtnCardTab = styled.div`
  width: 150px;
  flex: ${(props) => props.flex};
  height: auto;
  button {
    border-bottom: 2px solid ${(props) => props.borde};
    background: transparent;
    font-size: 14px;
    color: #3a3a3a;
    width: 100%;
    &:hover {
      border-color: ${(props) =>
    props.borde === "transparent" ? "#e4e4e4" : props.borde};
    }
    &:focus {
      outline: none;
    }
    disabled: {
      background: #f1f1f2;
      &:hover {
        border-bottom: 1px solid transparent;
        color: #999999;
      }
    }
  }
`;
